export default __webpack_public_path__ + "static/media/ico-sewa.c6cf5d6a.webp";